import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  orders: [],
  singleOrder: null,
};

export const createOrder = createAsyncThunk(
  "createOrder/order",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("orders", data);
      enqueueSnackbar("Order is added successfully");
      navigate(PATH_DASHBOARD.orders.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchOrders = createAsyncThunk(
  "fetchOrders/order",
  async (
    { enqueueSnackbar, limit = 10, page = 0, status = "processing", search },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.get(
        `orders?limit=${limit}&page=${page + 1}&status=${status}`,
        {
          params: {
            search,
          },
        }
      );

      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchSingleOrder = createAsyncThunk(
  "fetchSingleOrder/order",
  async ({ enqueueSnackbar, slug }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`orders/${slug}`);

      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateOrder = createAsyncThunk(
  "updateOrder/order",
  async ({ slug, data, enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`orders/${slug}`, data);
      console.log(response.data.data, "respom");
      thunkApi.dispatch(fetchOrders({ limit, page, enqueueSnackbar }));
      return {
        data: response.data.data,
        enqueueSnackbar,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "updateOrderStatus/order",
  async (
    { slug, data, enqueueSnackbar, limit, page, filterStatus },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.patch(`update-order/${slug}`, data);
      thunkApi.dispatch(
        fetchOrders({ enqueueSnackbar, limit, page, status: filterStatus })
      );

      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "deleteOrder/order",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`orders/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState,
  extraReducers: (builder) => {
    // TODO: create order
    builder.addCase(createOrder.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createOrder.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createOrder.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(fetchOrders.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchOrders.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.orders = action.payload;
    });

    builder.addCase(fetchOrders.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch single product
    builder.addCase(fetchSingleOrder.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSingleOrder.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singleOrder = action.payload;
    });

    builder.addCase(fetchSingleOrder.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update order
    builder.addCase(updateOrder.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateOrder.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Order is updated successfully");
      // state.orders.data = state.orders.data.map((order) =>
      //   order.code === action.payload.slug ? action.payload.data : order
      // );
      // action.payload.setOpenEdit(false);
    });

    builder.addCase(updateOrder.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete product
    builder.addCase(deleteOrder.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteOrder.fulfilled, (state, action) => {
      state.isLoading = false;
      state.orders.data = state.orders.data.filter(
        (order) => order.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("Order is deleted successfully");
    });

    builder.addCase(deleteOrder.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(updateOrderStatus.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(updateOrderStatus.fulfilled, (state) => {
      state.fetchLoading = false;
    });

    builder.addCase(updateOrderStatus.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default orderSlice.reducer;
